import baseAPI from './axiosApi'

const api={
    get:'/api-u/users/',
    forzen:'/api-u/users/',
}
//获取用户列表
export function getUserPage (parameter) {
    return baseAPI.axiosData(api.get,'get',parameter)
}
//删除用户
export function removeUser (id) {
    return baseAPI.axiosData(api.get+'/'+id,'delete')
}
//禁用或启用用户
export function frozenUserBatch (id,status) {
    return baseAPI.axiosData(api.forzen+id+'/'+status,'put')
}
//新增用户
export function addUser (parameter) {
    return baseAPI.axiosData(api.get,'post',parameter)
}
//编辑用户
export function updateUser (parameter) {
    return baseAPI.axiosData(api.get,'put',parameter)
}
//修改密码
export function changPassword (id, password) {
    return baseAPI.axiosData(api.forzen + id + '/password?newPassword=' + escape(password),'put')
}